import { createHash } from 'crypto'; 
import axios from 'axios';
import { parse } from 'qs';
import to from 'await-to-js';
import { container } from 'op/container';
import { compose, withState, withProps, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import jwt from 'jsonwebtoken';

export const withLoginForm = compose(
	connect(({ auth }) => ({
		loggedIn: auth.user && auth.user.auth.expires_at > Date.now(),
	}), (dispatch) => ({
		logInUser: (user) =>
			dispatch(
				container.resolve('actions').set_current_user(user),
			),
	})),
	withState('error', 'setError'),
	withState('loading', 'setLoading', false),
	withState('username', 'setUsername', ''),
	withState('password', 'setPassword', ''),
	withProps(({ location }) => ({
		next: parse(location.search.substr(1)).next || '/',
	})),
	withHandlers({
		login: ({ location, password, username, setLoading, logInUser, setError }) => async () => {
			setLoading(true);

			const [err, response] = await to(axios.post('/api/auth/authenticate', {
				username,
				password: createHash('sha256').update(password).digest('base64'),
			}));

			setLoading(false);
			if (!response.data.success){
				return setError(response.data.authError.errorMessage);
			}
			if (err){
				return setError(err);
			}

			var decoded = jwt.decode(response.data.accessToken);
			console.log(decoded.user);
			const user = container.resolve('transformers').user(JSON.parse(decoded.user));

			logInUser({
				...user,
				auth: {
					token: response.data.accessToken,
					token_type: 'Bearer',
					expires_at: (decoded.exp * 1000),
					refresh_token:response.data.refreshToken
				}
			});
		}
	}),
);

export default {
	withLoginForm,
}
